export const createApiActions = (name) => {
  return {
    add: (data, extra = {}) => ({
      type: `GET_${name}`,
      payload: data,
      ...extra,
    }),
    remove: () => ({
      type: `REMOVE_${name}`,
    }),
  };
};


export const CCApi1 = createApiActions("CCAPI1");
export const CCApi2 = createApiActions("CCAPI2");
export const CCApi3 = createApiActions("CCAPI3");
export const CCApi4 = createApiActions("CCAPI4");
export const CCApi5 = createApiActions("CCAPI5");
export const CCApi6 = createApiActions("CCAPI6");
export const CCApi6b = createApiActions("CCAPI6B");

export const CCApi7 = createApiActions("CCAPI7");
export const CCApi8 = createApiActions("CCAPI8");
export const CCApi9 = createApiActions("CCAPI9");
export const CCApi10 = createApiActions("CCAPI10");
export const CCApi11 = createApiActions("CCAPI11");
export const CCApi12 = createApiActions("CCAPI12");
export const CCApi14 = createApiActions("CCAPI14");
export const CCApi15 = createApiActions("CCAPI15");
export const CCApi16 = createApiActions("CCAPI16");
export const CCApi17 = createApiActions("CCAPI17");

export const CCApi20 = createApiActions("CCAPI20");
export const CCApi20a = createApiActions("CCAPI20a");







